<template>
    <LoadingPanel
        v-model:collapsed="collapsed"
        :headline="t('generators.conditionStatus.content.visualInspections.title')"
        :is-pending="isPending"
        :is-error="isError"
        collapsible
    >
        <ConditionStatusVisualInspectionsTable />
        <template #context>
            <pbl-button
                v-if="canEditComments"
                slot="context"
                variant="secondary"
                compact
                @click.stop="commentModal?.openComment()"
            >
                <pbl-icon
                    slot="icon"
                    name="plus"
                />
                {{ t('common.addComment') }}
            </pbl-button>
        </template>
    </LoadingPanel>
</template>

<script setup lang="ts">
import ConditionStatusVisualInspectionsTable from '@/pages/generators/condition-status/sections/visual-inspections/ConditionStatusVisualInspectionsTable.vue'
import LoadingPanel from '@/components/panel/LoadingPanel.vue'
import { useI18n } from 'vue-i18n'
import { useConditionStatusCommentModal } from '@/components/modals/comment/useConditionStatusCommentModal'
import { usePermissions } from '@/composables/usePermissions'
import { computed } from 'vue'
import { useGeneratorVisualInspectionsQuery } from '@/api/queries/generators/useGeneratorVisualInspectionsQuery'
import { useGeneratorId } from '@/composables/useGeneratorId'

const collapsed = defineModel<boolean>('collapsed', { default: true })

const { t } = useI18n()
const commentModal = useConditionStatusCommentModal()
const { userPermissions } = usePermissions()
const canEditComments = computed(() => userPermissions.value.canEditGeneratorComments)

const generatorId = useGeneratorId()
const { isPending, isError } = useGeneratorVisualInspectionsQuery(generatorId)
</script>
